import { useState, useRef, useEffect } from "react";
import "./LanguageDropdown.scss";
import downIcon from "../../assets/images/down-arrow.png";
import upIcon from "../../assets/images/up-arrow.png";
 
// export const LanguageDropdown = ({ label, options, value, onChange }) => {

//   const [open, setOpen] = useState(false);
//   const dropdownRef = useRef(null);

 
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const selectedOption = options.find((opt) => opt.value === value);

//   return (
//     <div className="inline-dropdown" ref={dropdownRef}>
//       {label && <div className="dropdown-label">{label}</div>}

//       <div
//         className={`dropdown-header ${open ? "open" : ""}`}
//         onClick={() => setOpen((prev) => !prev)}
//       >
//         <span className="dropdown-selected">
//           {selectedOption ? selectedOption.label : "-"}
//         </span>
//         <img
//           src={open ? upIcon : downIcon}
//           alt="arrow"
//           className="dropdown-arrow"
//           onClick={(e) => {
//             e.stopPropagation(); 
//             setOpen((prev) => !prev);
//           }}
//         />
//       </div>

//       {open && (
//         <ul className="dropdown-list">
//           {options.map((option) => (
//             <li
//               key={option.value}
//               className={`dropdown-item ${
//                 option.value === value ? "active" : ""
//               }`}
//               onClick={() => {
//                 onChange(option.value);
//                 setOpen(false);
//               }}
//             >
//               {option.label}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

export const LanguageDropdown = ({ label, options, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <div className="inline-dropdown" ref={dropdownRef}>
      {label && <div className="dropdown-label">{label}</div>}

      <div
        className={`dropdown-header ${open ? "open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="dropdown-selected">
          {selectedOption ? selectedOption.label : "-"}
        </span>
        <img
          src={open ? upIcon : downIcon}
          alt="arrow"
          className="dropdown-arrow"
          onClick={(e) => {
            e.stopPropagation(); 
            setOpen((prev) => !prev);
          }}
        />
      </div>

      {open && (
        <ul className="dropdown-list">
          {options.map((option) => (
            <li
              key={option.value}
              className={`dropdown-item ${
                option.value === value ? "active" : ""
              }`}
              onClick={() => {
                onChange(option.value); 
                setOpen(false);
              }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};